// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth"; // Import for Firebase Authentication
import { getFirestore } from "firebase/firestore"; // Import for Firestore
import { getStorage } from "firebase/storage"; // Import for Firebase Storage

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCT0TZbtgbdlNDU7MJKaUM5ZH820Z12yyg",
  authDomain: "toutmate-dd3e7.firebaseapp.com",
  projectId: "toutmate-dd3e7",
  storageBucket: "toutmate-dd3e7.appspot.com",
  messagingSenderId: "614406808321",
  appId: "1:614406808321:web:69d1c2acb075595791f100",
  measurementId: "G-HJDKP3KD47",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const auth = getAuth(app); // Initialize Firebase Authentication
const db = getFirestore(app); // Initialize Firestore Database
const storage = getStorage(app); // Initialize Firebase Storage

// Export the auth, db, and storage objects to use them in other parts of the project
export { auth, db, storage };
